(function ( $ ) {
    $.fn.quotationSelector = function(val, params) {
        $(this).each(function() {
            const elm = $(this);

            elm.attr('data-search-type', 'quotation');

            const onChange = function(obj) {
                if(typeof obj === 'string') {
                    obj = JSON.parse(obj);
                }
                squde_reload_for_flashes();
                elm.removeClass('has-special-selector').quotationSelector(obj.id, params);
            };

            elm.specialSelector({
                params: params,
                val: val,
                option: function(row) {
                    let nameStr = row.uid;
                    if (row.reference && row.reference.length > 0) {
                        nameStr += ' / ' + row.reference;
                    }
                    return '<option value="' + row.id + '">' + nameStr + '</option>';
                },
                addNew: function() {
                    add_quotation({
                        filters: elm.getSetFilters(),
                        callback: function(quotation) {
                            onChange(quotation);
                        }.bind([elm])
                    });
                }.bind([elm]),
                onOpen: function(id) {
                    view_quotation(id, function(quotation, elm, popup) {
                        onChange(quotation);
                        popup.close();
                    });
                }
            });
        });
        return this;
    };

}( jQuery ));